import { isAxiosError } from "axios"

import { parseAxiosError } from "~/utils/parseAxiosError"

/** Statuses whose `message` is the server's reason, written for the seller. */
const REASON_STATUSES = new Set([400, 403, 409])

/**
 * A refused command's own reason (a validation failure, a read-only actor, a
 * financing lock); anything else reads as the step's generic failure.
 */
export const describeCommandError = (
  error: unknown,
  fallback: string,
): string =>
  isAxiosError(error) && REASON_STATUSES.has(error.response?.status ?? 0)
    ? parseAxiosError(error, fallback)
    : fallback
